export const GET_STATUS_ALLOWED = 'GET_STATUS_ALLOWED'
export const GET_STATUS_ALLOWED_PENDING = 'GET_STATUS_ALLOWED_PENDING'
export const GET_STATUS_ALLOWED_FULFILLED = 'GET_STATUS_ALLOWED_FULFILLED'
export const GET_STATUS_ALLOWED_REJECTED = 'GET_STATUS_ALLOWED_REJECTED'
